import React from 'react';
import cs from 'classnames';
import { Grid } from '@forgeglobal/design-framework';
import useStyles from './BaseLayout.styles';
import MainDisclaimer from '@tcs/common/components/atoms/footer/MainDisclaimer';
import Header from './Header';

interface BaseLayoutProps {
  children: React.ReactNode;
  shouldShowUser?: boolean;
  className?: string;
  hideDisclaimer?: boolean;
}

const BaseLayout = ({
  children,
  shouldShowUser,
  className,
  hideDisclaimer = false,
}: BaseLayoutProps) => {
  const classes = useStyles();

  return (
    <>
      <Header shouldShowUser={shouldShowUser} />
      <Grid container className={cs(classes.main, className)}>
        <div className={classes.mainContainer}>
          {children}
          {!hideDisclaimer && <MainDisclaimer />}
        </div>
      </Grid>
    </>
  );
};

export default BaseLayout;
